<template>
  <el-row
    type="flex"
    justify="center"
  >
    <div class="search-box container">
      <el-form
        class="search-form"
        :label-position="labelPosition"
        :model="{}"
      >
        <el-col :sm="11">
          <el-form-item class="search">
            <el-input
              v-model="search"
              :placeholder="$t('search.search.placeholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="8">
          <el-form-item class="location">
            <location />
          </el-form-item>
        </el-col>
        <!--<el-col :sm="4" v-if="location">-->
        <!--<el-form-item class="km">-->
        <!--<select-primary-js-->
        <!--placeholder="Radius"-->
        <!--label="radius"-->
        <!--v-model="radius"-->
        <!--:item-key="'value'"-->
        <!--:searchable="false"-->
        <!--:options="radiusOptions">-->
        <!--</select-primary-js>-->
        <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :sm="5">
          <el-form-item class="search-button">
            <router-link
              :to="{ name: 'Search' }"
              tag="el-button"
              class="button"
            >
              {{ $t('search.search-text') }}
            </router-link>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </el-row>
</template>

<script>
/* eslint-disable no-param-reassign */

import { mapState } from 'vuex';
import { autoState } from '@fps/vue-toolkit/dist/util';
import mutations from '@/store/filters/filters.mutationlist';
import Location from '@/components/MainLeftFilters/Location';

export default {
  components: {
    Location,
  },
  data() {
    return {
      labelPosition: 'left',
      name: 'MainSearch',
    };
  },
  computed: {
    ...autoState(['search'], mutations.FILTER_SET, 500, 'filters'),
    // ...autoState(['radius'], mutations.FILTER_SET, 0, 'filters'),
    ...mapState({
      category: state => state.filters.category,
      locale: state => state.locale,
      reverseTextForLocals: state => state.filters.reverseTextForLocals,
      // radiusOptions: state => state.config.rangeOptions,
    }),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/MainSearch.vue